import axios from '@/lib/axios';
import { PurchaseOrderContractTask, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0810. 発注案件契約タスク削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
};

const destroyPurchaseOrderContractTask = (props: Props): Promise<PurchaseOrderContractTask> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.id}`
  );
};

export const useDestroyPurchaseOrderContractTask = () => {
  return useMutation({
    mutationFn: destroyPurchaseOrderContractTask,
  });
};
